import { useEffect, useRef } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import { useNotifications } from "./context/NotificationContext";

export default function GlobalNotifications({ user }) {
  const { pushNotification } = useNotifications();

  const lastMessagesRef = useRef({}); // анти-дубликаты

  useEffect(() => {
    if (!user) return;

    const unsub = onSnapshot(collection(db, "chats"), (snapshot) => {
      snapshot.docs.forEach((docSnap) => {
        const chat = docSnap.data();
        const chatId = docSnap.id;

        const lastMsg = chat.lastMessage;
        const sender = chat.lastMessageSender;

        if (!lastMsg || sender === user) return;

        // 💥 ЧИТАЕМ АКТУАЛЬНЫЙ ЧАТ ПРЯМО ИЗ window
        const activeChat = window.currentChatId;

        // ❌ если чат открыт — НЕ шлём уведомление
        if (activeChat === chatId) return;

        // 💥 анти-дубликаты (лучше по id, но пока ок)
        if (lastMessagesRef.current[chatId] === lastMsg) return;

        lastMessagesRef.current[chatId] = lastMsg;

       pushNotification({
  title: chat.isGroup
    ? chat.name
    : chat.lastMessageSenderName, // 👈 вот это важно

  text: lastMsg,

  avatar: chat.lastMessageSenderAvatar 
  ? chat.lastMessageSenderAvatar 
  : "/default-avatar.png",

  chatId: chatId,
});
      });
    });

    return () => unsub();
  }, [user]);

  return null;
}